exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1loVDSWsLhfe_k{display:flex}._3vWVhjKceliSH2{background-color:transparent;border-radius:3px;color:#6b778c;display:inline-block;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Noto Sans,Ubuntu,Droid Sans,Helvetica Neue,sans-serif;font-size:12px;font-weight:400;height:24px;line-height:24px;max-width:calc(100% - 16px);min-height:24px;overflow:hidden;padding:0 6px;text-overflow:ellipsis;vertical-align:top;white-space:nowrap}._3ckhypm1ocq4gn{align-items:center;display:flex;flex-shrink:0;height:24px;justify-content:center;width:16px}._3ckhypm1ocq4gn svg{height:16px;width:16px}.efjAjtO-U8uhw1{margin-left:4px}._21YN576zqCm3qo ._3vWVhjKceliSH2{margin-top:4px;margin-right:4px}", ""]);

// exports
exports.locals = {
	"flex": "_1loVDSWsLhfe_k",
	"badge": "_3vWVhjKceliSH2",
	"badgeIcon": "_3ckhypm1ocq4gn",
	"badgeIconLabel": "efjAjtO-U8uhw1",
	"cardFront": "_21YN576zqCm3qo"
};